<ng-container *ngIf="!disabled">
  <uni-icon *ngIf="type == 'password'" name="eye"></uni-icon>
  <uni-icon *ngIf="type == 'text'"  name="eye-slash"></uni-icon>
</ng-container>
